import React from "react";
import logo from "../../assets/logo.png";

const Logo: React.FC = () => {
  return (
    <div className="dqm-tcui-logo">
      <img src={logo} alt="Telia logo"></img>
    </div>
  );
};

export default Logo;
